export const tableItemsSm = [
  {
    id: "user-id",
    name: "User ID",
    trsText: "userId"
  },
  {
    id: "user-name",
    name: "User Name",
    trsText: "userName"
  },
];

export const tableItemsMd = [
  {
    id: "user-id",
    name: "User ID",
    trsText: "userId"
  },
  {
    id: "user-name",
    name: "User Name",
    trsText: "userName"
  },
  {
    id: "email",
    name: "Email",
    trsText: "email"
  },
];

export const tableItemsLg = [
  {
    id: "user-id",
    name: "User ID",
    trsText: "userId"
  },
  {
    id: "user-name",
    name: "User Name",
    trsText: "userName"
  },
  {
    id: "email",
    name: "Email",
    trsText: "email"
  },
  // {
  //   id: "agent-id",
  //   name: "Agent ID",
  // },
  {
    id: "branch-name",
    name: "Branch Name",
    trsText: "branchName"
  },
];
